import "core-js/modules/es.array.join.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.array.find.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.array.is-array.js";
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.symbol.description.js";
import "core-js/modules/es.symbol.iterator.js";
import "core-js/modules/es.array.iterator.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/web.dom-collections.iterator.js";
import "core-js/modules/es.array.slice.js";
import "core-js/modules/es.function.name.js";
import "core-js/modules/es.array.from.js";
import "core-js/modules/es.regexp.exec.js";
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
import { useEffect, useState } from 'react';
import { Button, Dialog, Flex, Notice, RadioGroup, Text, useToasts } from '@applyboard/crystal-ui';
import { CheckCircleOutlineIcon } from '@applyboard/ui-icons';
import { useReloadApplicationPageAggregatedData } from "../../data/aggregatedData";
import { useLegacyPIICenterDeleteAttachmentObjects } from "../../data/piiCenter";
import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import { jsxs as _jsxs } from "@emotion/react/jsx-runtime";
export var LegacyRemoveFileDialog = function LegacyRemoveFileDialog(props) {
  var _useState = useState(null),
    _useState2 = _slicedToArray(_useState, 2),
    showSuccessDialog = _useState2[0],
    setShowSuccessDialog = _useState2[1];
  var _useState3 = useState({}),
    _useState4 = _slicedToArray(_useState3, 2),
    onSuccessData = _useState4[0],
    setOnSuccessData = _useState4[1];
  if (!props.attachmentId || !props.fileName) {
    return null;
  }
  if (showSuccessDialog !== null && !props.isOpen) {
    var _onSuccessData$remove;
    return _jsx(SuccessDialog, {
      isOpen: showSuccessDialog,
      onOpenChange: function onOpenChange(open) {
        if (onSuccessData.successfullyDeletedFiles) {
          props.onSuccess({
            successfullyDeletedFiles: onSuccessData.successfullyDeletedFiles,
            requirementStatus: onSuccessData.requirementStatus
          });
        }
        setShowSuccessDialog(open);
      },
      fileName: props.fileName,
      removedApplications: (_onSuccessData$remove = onSuccessData === null || onSuccessData === void 0 ? void 0 : onSuccessData.removedApplications) !== null && _onSuccessData$remove !== void 0 ? _onSuccessData$remove : []
    });
  }
  return _jsx(RemoveDialog, {
    isOpen: props.isOpen,
    isRemovingFile: props.isRemovingFile,
    onOpenChange: props.onOpenChange,
    applicationId: props.applicationId,
    requirementId: props.requirementId,
    requirementType: props.requirementType,
    attachmentId: props.attachmentId,
    fileName: props.fileName,
    isPiiDeleteSynced: props.isPiiDeleteSynced,
    onConfirmNonPiiDelete: props.onConfirmNonPiiDelete,
    onSuccess: function onSuccess(params) {
      setShowSuccessDialog(true);
      setOnSuccessData({
        successfullyDeletedFiles: params.successfullyDeletedFiles,
        requirementStatus: params.requirementStatus,
        removedApplications: params.removedApplicationIds
      });
    }
  });
};
var SuccessDialog = function SuccessDialog(props) {
  return _jsxs(Dialog, {
    open: props.isOpen,
    onOpenChange: props.onOpenChange,
    children: [_jsx(Dialog.Heading, {
      children: "File Successfully Removed"
    }), _jsx(Dialog.Content, {
      children: _jsxs(Flex, {
        gap: 5,
        children: [_jsx(Flex.Item, {
          children: _jsx(CheckCircleOutlineIcon, {
            intent: "positive",
            size: "xl"
          })
        }), _jsxs(Text, {
          children: ["File ", props.fileName, " has been successfully removed from this application", props.removedApplications.length ? " and the\n                following applications ".concat(props.removedApplications.map(function (app) {
            return "ID ".concat(app);
          }).join(', ')) : '', "."]
        })]
      })
    }), _jsx(Dialog.Actions, {
      children: _jsx(Button, {
        width: "fill",
        intent: "primary",
        onClick: function onClick() {
          return props.onOpenChange(false);
        },
        children: "OK"
      })
    })]
  });
};
var RemoveDialog = function RemoveDialog(props) {
  var toasts = useToasts();
  var _useState5 = useState('yes'),
    _useState6 = _slicedToArray(_useState5, 2),
    isPii = _useState6[0],
    setIsPii = _useState6[1];
  var _useLegacyPIICenterDe = useLegacyPIICenterDeleteAttachmentObjects(),
    deleteRequirementAttachments = _useLegacyPIICenterDe.deleteRequirementAttachments,
    isDeletingRequirementAttachments = _useLegacyPIICenterDe.isDeletingRequirementAttachments;
  var _useReloadApplication = useReloadApplicationPageAggregatedData(),
    reloadApplicationPageAggregatedData = _useReloadApplication.reloadApplicationPageAggregatedData;

  // eslint-disable-next-line no-restricted-syntax -- TODO: try to remove this useEffect
  useEffect(function () {
    if (!props.isOpen) {
      setIsPii('yes');
    }
  }, [props.isOpen]);
  return _jsxs(Dialog, {
    open: props.isOpen,
    onOpenChange: props.onOpenChange,
    children: [_jsx(Dialog.Heading, {
      children: "Remove File?"
    }), _jsx(Dialog.Content, {
      children: _jsxs(Flex, {
        gap: 2,
        direction: "column",
        children: [_jsxs(Flex, {
          gap: 4,
          direction: "column",
          children: [_jsxs(Text, {
            children: ["Do you want to remove the file ", props.fileName, "?"]
          }), _jsx(Text, {
            children: "To remove the file please specify a reason of the file removal."
          }), _jsx(RadioGroup, {
            value: isPii,
            label: "Is removal reason Personal Identifiable Information (PII) incident?",
            onChange: setIsPii,
            children: _jsxs(Flex, {
              gap: 2,
              children: [_jsx(RadioGroup.Option, {
                label: "Yes",
                value: "yes"
              }), _jsx(RadioGroup.Option, {
                label: "No",
                value: "no"
              })]
            })
          })]
        }), isPii !== '' && _jsx(Notice, {
          intent: "warning",
          children: props.isPiiDeleteSynced && isPii === 'yes' ? 'On confirmation, this file will be removed from this application and all other applications opened for this particular student.' : 'On confirmation, this file will be removed from this requirement only. No other requirements will be affected.'
        })]
      })
    }), _jsxs(Dialog.Actions, {
      children: [_jsx(Dialog.CloseButton, {
        width: "fill",
        children: "Cancel"
      }), _jsx(Button, {
        width: "fill",
        intent: "negative",
        disabled: !isPii,
        loading: isDeletingRequirementAttachments || props.isRemovingFile,
        onClick: function onClick() {
          if (isPii === 'yes') {
            deleteRequirementAttachments({
              applicationId: props.applicationId,
              attachmentId: props.attachmentId,
              requirementId: props.requirementId
            }, {
              onSuccess: function onSuccess(_ref) {
                var _successfullyDeletedF, _successfullyDeletedF2, _successfullyDeletedF3;
                var successfullyDeletedFiles = _ref.successfullyDeletedFiles,
                  requirementStatus = _ref.requirementStatus;
                props.onOpenChange(false);
                var removedApplicationIds = (successfullyDeletedFiles === null || successfullyDeletedFiles === void 0 ? void 0 : (_successfullyDeletedF = successfullyDeletedFiles.find(function (deletedFiles) {
                  return deletedFiles.type === 'attachment';
                })) === null || _successfullyDeletedF === void 0 ? void 0 : (_successfullyDeletedF2 = _successfullyDeletedF.attributes) === null || _successfullyDeletedF2 === void 0 ? void 0 : (_successfullyDeletedF3 = _successfullyDeletedF2.deletedApplicationRequirementAttachments) === null || _successfullyDeletedF3 === void 0 ? void 0 : _successfullyDeletedF3.map(function (applicationRequirement) {
                  return applicationRequirement.applicationId;
                })) || [];
                reloadApplicationPageAggregatedData();
                props.onSuccess({
                  successfullyDeletedFiles: successfullyDeletedFiles,
                  requirementStatus: requirementStatus,
                  removedApplicationIds: removedApplicationIds
                });
              },
              onError: function onError() {
                toasts.negative(new Error("Failed to remove file ".concat(props.fileName, ".pdf")));
              }
            });
          } else {
            props.onConfirmNonPiiDelete();
          }
        },
        children: "Remove"
      })]
    })]
  });
};